import { Routes } from '@angular/router';

import { CallbackComponent } from './components/callback/callback.component';
import { HomeComponent } from './components/home/home.component';
import { ACCOUNT_USER_ROUTES } from '@account-users';
import { EMAIL_ROUTES } from '@email';
import { MA_ROUTES } from '@ma';
import { INTEGRATIONS_ROUTES } from '@integrations';
import { ECOM_ROUTES } from '@ecom';
import { DELIVERY_STATISTICS_ROUTES } from '@delivery-statistics';
import { MIGRATIONS_ROUTES } from '@migrations';
import { PRIVATE_DOMAIN_ROUTES } from '@private-domain';
import { ROLES_ROUTES } from '@roles';
import { BOSS_ROUTES } from '@boss';
import { TRIAL_ACCOUNTS_ROUTES } from '@trial-accounts';
import { AuthGuard } from '@account-users';

export const ROUTES: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'au',
    children: ACCOUNT_USER_ROUTES,
    canActivate: [AuthGuard],
  },
  {
    path: 'email',
    children: EMAIL_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Email | One Back Office' },
  },
  {
    path: 'statistics',
    children: DELIVERY_STATISTICS_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Statistics | One Back Office' },
  },
  {
    path: 'ma',
    children: MA_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Marketing Automation | One Back Office' },
  },
  {
    path: 'integrations',
    children: INTEGRATIONS_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Integrations Statistics | One Back Office' },
  },
  {
    path: 'migrations',
    children: MIGRATIONS_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Migrations | One Back Office' },
  },
  {
    path: 'ecom',
    children: ECOM_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Ecom | One Back Office' },
  },
  {
    path: 'private-domain',
    children: PRIVATE_DOMAIN_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Private Domain | One Back Ofice' },
  },
  {
    path: 'roles',
    children: ROLES_ROUTES,
    canActivate: [AuthGuard],
    data: { title: 'Roles | One Back Office' },
  },
  {
    path: 'boss',
    children: BOSS_ROUTES,
    data: { title: 'Back Office Stats | One Back Office' },
  },
  {
    path: 'trial-accounts',
    children: TRIAL_ACCOUNTS_ROUTES,
    data: { title: 'Trial Accounts Requests | One Back Office' },
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: '*',
    redirectTo: '',
  },
];
